module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Medium-Alphabetic.4d57e86b.woff2";